import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

// Import React Table
//import ReactTable from "react-table";
import {Table} from "reactstrap";

/*
class DragTrComponent extends Component {

    render() {
        const { children = null, rowInfo, key, id } = this.props;
        if (rowInfo) {
            const { original, index} = rowInfo;
            return (
                <Draggable key={original[key]} index={index} draggableId={original[id]}>
                    {(draggableProvided, draggableSnapshot) => (
                        <div
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            {...draggableProvided.dragHandleProps}
                        >
                            <ReactTable.defaultProps.TrComponent style={{ width: '100%' }}>
                                {children}
                            </ReactTable.defaultProps.TrComponent>
                        </div>
                    )}
                </Draggable>
            );
        } else
            return (
                <ReactTable.defaultProps.TrComponent  >
                    {children}
                </ReactTable.defaultProps.TrComponent>
            );
    }
}

class DropTbodyComponent extends React.Component {
    render() {
        const { children = null } = this.props;

        return (
            <Droppable droppableId="droppable">
                {(droppableProvided, droppableSnapshot) => (
                    <div ref={droppableProvided.innerRef}>
                        <ReactTable.defaultProps.TbodyComponent  >
                            {children}
                        </ReactTable.defaultProps.TbodyComponent>
                        {droppableProvided.placeholder}
                    </div>
                )}
            </Droppable>
        );
    }
}
*/

class ReorderTable extends Component {
    handleDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const data = reorder(
            this.props.data,
            result.source.index,
            result.destination.index
        );

        this.props.update(data);
    };

    getTrProps = (state, rowInfo) => {
        return { rowInfo };
    };

    render() {
        const { data } = this.props;
        /*DragTrComponent.defaultProps = {
            key: this.props.keyName,
            id: this.props.idName,
        }*/
        return (
            <div className="border">
                <DragDropContext onDragEnd={this.handleDragEnd}>
                    {/*
                    <ReactTable
                        TrComponent={DragTrComponent}
                        TbodyComponent={DropTbodyComponent}
                        getTrProps={this.getTrProps}
                        data={data}
                        className="-highlight -striped"
                        columns={this.props.columns}
                        showPagination={false}
                        sortable={false}
                        style={{
                            height: "400px",
                            overflow: "hidden"
                        }}
                    />
                    */}
                    {data ? (
                    <Table borderless size="sm">
                        <thead className="border-bottom">
                            <tr>
                                {this.props.columns.map(col => (col.show === false ? null : (
                                    <th key={col.accessor}> {col.Header} </th>
                                )))}
                            </tr>
                        </thead>
                        <Droppable droppableId="droppable">
                            {(droppableProvided, droppableSnapshot) =>
                                <tbody ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
                                    {data.map((d, index) => (d ? (
                                        <Draggable key={d[this.props.keyName]} index={index} draggableId={d[this.props.idName]}>
                                            {(draggableProvided, draggableSnapshot) => (
                                                <tr
                                                    ref={draggableProvided.innerRef}
                                                    {...draggableProvided.draggableProps}
                                                    {...draggableProvided.dragHandleProps}
                                                >
                                                    {this.props.columns.map(col => (col.show === false ? null : (
                                                        <td key={d[this.props.keyName]}>
                                                            {d[col.accessor]}
                                                        </td>
                                                    )))}
                                                </tr>
                                            )}
                                        </Draggable>
                                    ) : null))}
                                    {droppableProvided.placeholder}
                                </tbody>
                            }
                        </Droppable>
                    </Table>
                        ) : null}
                </DragDropContext>
            </div>
        );
    }
}

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export default ReorderTable;
